import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { USD_MOCK_TOKEN } from '@/domain/types/Token'
import { Progress } from '@/features/sparklend/market-details/components/debt-ceiling-progress/Progress'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { links } from '@/ui/constants/links'
import { Info } from '@/ui/molecules/info/Info'
import { UsdAmountTooltip } from '@/ui/organisms/usd-amount-tooltip/UsdAmountTooltip'
import { cn } from '@/ui/utils/style'
import { testIds } from '@/ui/utils/testIds'

interface DebtCeilingProgressProps {
  debt: NormalizedNumber
  debtCeiling: NormalizedNumber
  className?: string
}

export function DebtCeilingProgress({ debt, debtCeiling }: DebtCeilingProgressProps) {
  const value = debt.div(debtCeiling).times(100).toNumber()

  const hasCeilingBeenReached = value === 100

  return (
    <div className="col-span-3 mt-6 flex flex-col gap-4 rounded-sm border border-primary p-4 sm:col-span-2 sm:col-start-2 sm:mt-8">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1 text-secondary">
          <p className="typography-label-4">Isolated Debt Ceiling</p>
          <Info className="text-inherit">
            Debt ceiling limits the amount possible to borrow against this asset by protocol users. Debt ceiling is
            specific to assets in isolation mode and is denoted in USD.{' '}
            <ExternalLink to={links.docs.isolationModeBorrowingPower}>Learn more</ExternalLink>
          </Info>
        </div>
        <p className="typography-label-4">
          <span
            className={cn('text-primary', hasCeilingBeenReached && 'text-system-error-primary')}
            data-testid={testIds.marketDetails.collateralStatusPanel.debt}
          >
            <UsdAmountTooltip token={USD_MOCK_TOKEN} amount={debt} style="compact" />
          </span>
          <span className="text-secondary">
            {' '}
            of{' '}
            <span data-testid={testIds.marketDetails.collateralStatusPanel.debtCeiling}>
              <UsdAmountTooltip token={USD_MOCK_TOKEN} amount={debtCeiling} style="compact" />
            </span>
          </span>
        </p>
      </div>
      <Progress value={value} variant={hasCeilingBeenReached ? 'finished' : 'in-progress'} />
    </div>
  )
}
